import { useRouter } from "next/router";

export const useShowNav = () => {
  const router = useRouter();

  const path = router.asPath;

  const standalonePages = ["/forceUpdate"];

  const showNav = !standalonePages.includes(path);

  return showNav;
};
